import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-sentry",
  "use": "icon-sentry-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" id=\"icon-sentry\"><path d=\"M23.7 21.859c.4-.715.4-1.567 0-2.282L13.92 2.141a2.184 2.184 0 0 0-3.84 0L6.92 7.774l.803.476a15.701 15.701 0 0 1 5.662 5.833 16.28 16.28 0 0 1 2.048 7.012H13.22a13.967 13.967 0 0 0-1.747-5.876 13.467 13.467 0 0 0-4.856-5l-.801-.476-2.955 5.27.802.475C5.626 16.652 7 18.793 7.285 21.095H2.22a.353.353 0 0 1-.317-.188.375.375 0 0 1 0-.377l1.412-2.518a5.101 5.101 0 0 0-1.605-.948L.3 19.577c-.4.715-.4 1.567 0 2.282A2.184 2.184 0 0 0 2.22 23h6.972v-.952a9.696 9.696 0 0 0-1.233-4.74 9.401 9.401 0 0 0-2.593-2.952l1.11-1.978a11.643 11.643 0 0 1 3.394 3.794 12.018 12.018 0 0 1 1.532 5.875V23h5.908l.001-.952c.003-3.119-.8-6.202-2.323-8.918a17.646 17.646 0 0 0-5.551-6.032l2.246-4.005A.351.351 0 0 1 12 2.905c.079 0 .225.024.317.188l9.78 17.437a.373.373 0 0 1 0 .376.353.353 0 0 1-.317.189h-2.298c.029.636.032 1.272.002 1.905h2.296c.8 0 1.518-.427 1.92-1.141\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-sentry.svg
// module id = 887
// module chunks = 74